import { assignCommonProperties } from '../util/data/assign-common-properties.js'

import { jsonProperty, jsonClass } from '@sumbricht/json-class-serializer'

@jsonClass('ServerDataStoreView')
export class ServerDataStoreView {
	@jsonProperty(String)
	name!: string
	@jsonProperty(String)
	code?: string

	constructor(init?: Partial<ServerDataStoreView>) {
		assignCommonProperties(this, init)
	}
}
